import React from 'react'
import { Link } from 'gatsby'

import { FiFileText } from 'react-icons/fi'
import { render } from '~utils/rehype-render'

import { 
  description,
  item, 
  title, 
  padded, 
  types, 
  object, 
  spacer
} from './Response.module.scss'

const Response = ({ 
  response, 
  microcopy
}) => (
  <div className={ item } id={ response.anchor }> 
    <div className={ padded }>

      <div className={ title }>
        <label><a href={ `#${response.anchor}` } data-display-anchor>{ response.code }</a></label>
        
        <span className={types}>{ 
          response.contentType || microcopy.text('reference.content_type.none')
        }</span>

        { response.resources?.[0] && response.resources.map((resource, index) => (
          <>
            { index > 0 && <span className={spacer}>/</span>}
            <span key={index} className={object}>
              <Link to={ resource.path }>
                <FiFileText />
                { resource.title }
              </Link>
            </span>
          </>
        ))}
      </div>

      <div className={description}>{ render(response.descriptionAst) }</div>

    </div>
  </div>
)

export default Response
